// extracted by mini-css-extract-plugin
export default {"MoviesComponent":"Movies_MoviesComponent__gamPj","MoviesComponentDiv":"Movies_MoviesComponentDiv__HPOD-"};